"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const breakpoints_1 = __importDefault(require("../../theme/breakpoints"));
const typography_1 = __importDefault(require("../../theme/typography"));
const form = {
    MuiFormLabel: {
        styleOverrides: {
            root: {
                color: colors_1.default.text[600],
                "&.Mui-disabled": {
                    color: colors_1.default.inputDisabled[100],
                },
                fontSize: typography_1.default.caption.fontSize,
                [breakpoints_1.default.up("sm")]: {
                    fontSize: "0.65rem",
                },
                [breakpoints_1.default.up("xl")]: {
                    fontSize: "0.7rem",
                },
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            label: {
                fontSize: "1rem",
                "&.Mui-disabled": {
                    color: colors_1.default.inputDisabled[100],
                },
            },
            root: {
                color: colors_1.default.text[600],
                pb: "0 !important",
            },
        },
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                marginLeft: 0,
                marginTop: "0.5rem",
                "&.Mui-disabled": {
                    color: colors_1.default.text[600],
                },
            },
        },
    },
};
exports.default = form;
